<h3 *ngIf="data == null" mat-dialog-title>Cadastrar Relacionamento com Cliente</h3>
<h3 *ngIf="data != null" mat-dialog-title>Alterar Relacionameto com Cliente</h3>
<div mat-dialog-content>

    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row" *ngIf="data.cliente">
        <mat-form-field appearance="outline" fxFlex="100" style="width: 100%" *ngIf="showClient">
            <mat-label>Cliente</mat-label>
            <input 
                matInput 
                placeholder="Digite o nome ou conta de um cliente" 
                aria-label="Cliente"  
                [formControl]="cliente" 
                name="cliente" 
                [matAutocomplete]="auto"
            >
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"  (optionSelected)='getCliente($event.option.value)'>
                <mat-option *ngFor="let cliente of filteredOptions | async" [value]="cliente">
                    <span> {{cliente.nome}}</span> |
                    <small>Conta: {{cliente.numero_xp }}</small>
                </mat-option>
            </mat-autocomplete>
            <mat-icon matSuffix class="secondary-text" *ngIf="!loadingSpinner">account_circle</mat-icon>
            <mat-spinner diameter="20" *ngIf="loadingSpinner"></mat-spinner>
        </mat-form-field>
    </div>
    
    <div fxLayout="row wrap">
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
            <mat-label>Ação</mat-label>
            <input matInput *ngIf="!data" [formControl]="acao_id" [readonly]="true">
            <mat-error *ngIf="acao_id.invalid">{{getErrorAcaoMessage()}}</mat-error>
            <mat-select placeholder="Ação"
                        [(value)]="model.acao_id" 
                        [formControl]="acao_id"
                        name="acao_id"
                        *ngIf="data" >
                    <mat-option value="">SELECIONE</mat-option>
                    <mat-option *ngFor="let acao of listAcao" [value]="acao.id">{{acao.nome}}</mat-option>
            </mat-select>
            <mat-spinner diameter="20" *ngIf="loadingSpinnerAcao"></mat-spinner>
        </mat-form-field>
    </div>
    
    <div fxLayout="row wrap">
        <mat-form-field style="width: 100%" appearance="outline">
            <mat-label>Observação</mat-label>
            <textarea
                matInput 
                placeholder="Observação" 
                [formControl]="observacao" 
                required
                [rows]="5"></textarea>
            <mat-error *ngIf="observacao.invalid">{{getErrorObservacaoMessage()}}</mat-error>
        </mat-form-field>
    </div>


</div>
<div mat-dialog-actions>
    <button 
        mat-button 
        tabindex="2" 
        (click)="onNoClick()"
    >
        Cancelar
    </button>
    <button 
        mat-button 
        [disabled]="isInvalidForm()" 
        (click)="salvar()" 
        tabindex="-1"
    >
        Salvar
    </button>
</div>